import * as React from 'react';
export const FeatherIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill={props.fill || '#fff'}
      d="M17.288 2.715a5 5 0 0 0-7.07 0l-5.476 5.41a1.242 1.242 0 0 0-.367.884v5.732l-2.317 2.317a.626.626 0 0 0 .885.884l2.317-2.317h5.732a1.245 1.245 0 0 0 .883-.366l5.409-5.468a4.999 4.999 0 0 0 .004-7.076Zm-6.188.884a3.75 3.75 0 0 1 5.446 5.151h-4.41l2.683-2.683a.625.625 0 1 0-.884-.884L9.375 9.74V5.302L11.1 3.6ZM5.625 9.012l2.5-2.474v4.453l-2.5 2.5V9.01Zm5.367 5.363H6.51L10.885 10h4.433l-4.325 4.375Z"
    />
  </svg>
);
